import { render } from "./BusinessFeatures.vue?vue&type=template&id=968fa7c0"
import script from "./BusinessFeatures.vue?vue&type=script&lang=js"
export * from "./BusinessFeatures.vue?vue&type=script&lang=js"

import "./BusinessFeatures.vue?vue&type=style&index=0&id=968fa7c0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__